/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
import {RoutePaths} from '../../../../app/routing/RoutePath'

const QuickLinks: FC = () => {
  const navigate = useNavigate()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-350px'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-8 new-gray-bg'
        // style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}
      >
        <h3 className='fw-bold'>Quick Help Links</h3>

        {/* <span className='badge bg-primary py-2 px-3'>25 pending tasks</span> */}
      </div>

      <div className='row g-0'>
        {/* <div className='col-6'>
        <a
          href='#'
          className='d-flex flex-column flex-center h-100 py-6 px-3 bg-hover-light border-end border-bottom'
        >
          <KTSVG
            path='/media/icons/duotune/social/soc007.svg'
            className='svg-icon-3x svg-icon-primary mb-2'
          />
          <span className='fs-6 fw-bold text-gray-800 mb-0'>Video Tutorials</span>
          <span className='fs-7 text-gray-400 text-center'>New videos every month</span>
        </a>
      </div> */}
        <div className='col-6'>
          <a
            href='#'
            onClick={() => {
              navigate(RoutePaths.howToVideos)
            }}
            className='d-flex flex-column flex-center h-100 py-6 px-3 bg-hover-light border-2 border-bottom border-end'
          >
            <KTSVG
              path='/media/icons/duotune/social/soc007.svg'
              className='svg-icon-3x svg-icon-primary mb-2'
            />
            <span className='fs-6 fw-bold text-gray-800 mb-0'>How To Videos</span>
            <span className='fs-7 text-gray-400 text-center'>New Videos every month</span>
          </a>
        </div>
        <div className='col-6'>
          <a
            href='https://support.cellcast.com.au'
            target='_blank'
            className='d-flex flex-column flex-center h-100 py-6 px-3 bg-hover-light border-2 border-bottom'
          >
            <KTSVG
              path='/media/icons/duotune/technology/teh001.svg'
              className='svg-icon-3x svg-icon-primary mb-2'
            />
            <span className='fs-6 fw-bold text-gray-800 mb-0'>Knowledge Base</span>
            <span className='fs-7 text-gray-400 text-center'>New articals and posts</span>
          </a>
        </div>

        <div className='col-6'>
          <a
            href='https://cellcastsms.atlassian.net/servicedesk/customer/portals'
            className='d-flex flex-column flex-center h-100 py-6 px-3 border-2 bg-hover-light border-end'
            target='_blank'
            rel='noreferrer'
          >
            <KTSVG
              path='/media/icons/duotune/coding/cod009.svg'
              className='svg-icon-3x svg-icon-primary mb-2'
            />
            <span className='fs-6 fw-bold text-gray-800 mb-0'>Support Tickets</span>
            <span className='fs-7 text-gray-400 d-flex text-center'>Load of support tickets</span>
          </a>
        </div>

        <div className='col-6' />

        {/* <div className='col-6'>
        <a className='d-flex flex-column flex-center h-100 py-6 px-3 bg-hover-light'>
          <KTSVG
            path='/media/icons/duotune/finance/fin006.svg'
            className='svg-icon-3x svg-icon-primary mb-2'
          />
          <span className='fs-5 fw-bold text-gray-800 mb-0'>Talk to us</span>
          <span className='fs-7 text-gray-400 text-center'>We're here for you</span>
        </a>
      </div> */}
      </div>

      {/* <div className='py-1 text-center border-top'>
      <Link to='/dashboard' className='btn btn-color-gray-600 btn-active-color-primary'>
        View All <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
      </Link>
    </div> */}
    </div>
  )
}

export {QuickLinks}
